import { AfterViewInit, Directive, ElementRef, HostListener, Input, OnDestroy, Output, Renderer2 } from '@angular/core';
import { el } from 'date-fns/locale';

@Directive({
  selector: '[draggable]'
})
export class DraggableDirective implements AfterViewInit, OnDestroy {

  constructor(private element: ElementRef<HTMLElement>, private renderer: Renderer2) {
    this.handleDragStart = this.handleDragStart.bind(this);
    this.handleDragEnd = this.handleDragEnd.bind(this);
    this.handleDrag = this.handleDrag.bind(this);
  }

    @Input() dragComponentGenerator: (event: DragEvent) => HTMLElement | undefined = (ev: DragEvent) => {
    const el = document.createElement('div');
    el.innerHTML = 'Drag';
    el.style.position = 'fixed';
    ev.dataTransfer!.effectAllowed = 'move';
    ev.dataTransfer!.setData('application/sl-date-event.json', JSON.stringify({}));
    document.body.appendChild(el);
    return el;
  };
  dragComponent: HTMLElement | undefined;
  emptyDragCanvas: HTMLCanvasElement = document.createElement('canvas');

  ngAfterViewInit(): void {
    this.element.nativeElement.addEventListener('dragstart', this.handleDragStart);
    this.element.nativeElement.addEventListener('drag', this.handleDrag);
    this.element.nativeElement.addEventListener('dragend', this.handleDragEnd);

    this.emptyDragCanvas.style.opacity = '0.01';
    this.emptyDragCanvas.style.width = '1px';
    this.emptyDragCanvas.style.height = '1px';
    this.emptyDragCanvas.style.position = 'absolute';
    this.emptyDragCanvas.className = 'empty-draggable';
    document.body.appendChild(this.emptyDragCanvas);
  }

  ngOnDestroy(): void {
    this.element.nativeElement.removeEventListener('dragstart', this.handleDragStart);
    this.element.nativeElement.removeEventListener('drag', this.handleDrag);
    this.element.nativeElement.removeEventListener('dragend', this.handleDragEnd);
  }

  handleDragStart(ev: DragEvent) {
    if(ev.dataTransfer != null) {
      this.dragComponent = this.dragComponentGenerator!(ev);
      ev.dataTransfer.setDragImage(this.emptyDragCanvas, 0, 0);
    }
  }

  handleDrag(ev: DragEvent) {
    if(ev.clientX > 0) {
      // If drag ends on an invalid target, some browser will freak out. 
      // This will make sure that we do not move the dragComponent to the top left corner.
      this.dragComponent!.style.left = ev.clientX + 5 + 'px';
      this.dragComponent!.style.top = ev.clientY + 5 +'px';
    }
  }

  handleDragEnd(ev: DragEvent) {
    this.dragComponent!.style.display = 'none';
    document.body.removeChild(this.dragComponent!);
  }


}